module.exports = __webpack_public_path__ + "static/media/egg_xiazai_canjia.c233c2a6.png";